// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateHsaWithdrawalClaimDto
 */
export interface ICreateHsaWithdrawalClaimDto {
    /**
     * 
     * @type {number}
     * @memberof ICreateHsaWithdrawalClaimDto
     */
    account_id: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateHsaWithdrawalClaimDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateHsaWithdrawalClaimDto
     */
    employee_notes?: string;
    /**
     * 
     * @type {number}
     * @memberof ICreateHsaWithdrawalClaimDto
     */
    payment_method_id: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateHsaWithdrawalClaimDto
     */
    source: ICreateHsaWithdrawalClaimDtoSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof ICreateHsaWithdrawalClaimDto
     */
    document_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum ICreateHsaWithdrawalClaimDtoSourceEnum {
    WEBSITE = 'WEBSITE',
    CLAIM_PROCESSOR = 'CLAIM_PROCESSOR',
    MOBILE_APP = 'MOBILE_APP',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    FILE = 'FILE',
    PAYMENT_CARD_TRX = 'PAYMENT_CARD_TRX'
}


/**
 * Check if a given object implements the ICreateHsaWithdrawalClaimDto interface.
 */
export function instanceOfICreateHsaWithdrawalClaimDto(value: object): value is ICreateHsaWithdrawalClaimDto {
    if (!('account_id' in value) || value['account_id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('payment_method_id' in value) || value['payment_method_id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function ICreateHsaWithdrawalClaimDtoFromJSON(json: any): ICreateHsaWithdrawalClaimDto {
    return ICreateHsaWithdrawalClaimDtoFromJSONTyped(json, false);
}

export function ICreateHsaWithdrawalClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateHsaWithdrawalClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'],
        'amount': json['amount'],
        'employee_notes': json['employee_notes'] == null ? undefined : json['employee_notes'],
        'payment_method_id': json['payment_method_id'],
        'source': json['source'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
    };
}

export function ICreateHsaWithdrawalClaimDtoToJSON(json: any): ICreateHsaWithdrawalClaimDto {
    return ICreateHsaWithdrawalClaimDtoToJSONTyped(json, false);
}

export function ICreateHsaWithdrawalClaimDtoToJSONTyped(value?: ICreateHsaWithdrawalClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'amount': value['amount'],
        'employee_notes': value['employee_notes'],
        'payment_method_id': value['payment_method_id'],
        'source': value['source'],
        'document_id': value['document_id'],
    };
}

